import React from "react";
import { Modal } from "antd";
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const PendingApprovalModal = ({ visible, status, onClose, onContinue }) => {
  const getModalConfig = (status) => {
    switch (status) {
      case "pending":
        return {
          title: "Business Approval Pending",
          icon: (
            <ClockCircleOutlined
              style={{ fontSize: "48px", color: "#faad14" }}
            />
          ),
          message:
            "Your business application is under review. We'll notify you once the approval process is complete.",
          bgColor: "bg-yellow-50",
          borderColor: "border-yellow-200",
          textColor: "text-yellow-800",
          closable: false, // Non-removable
        };
      case "approved":
        return {
          title: "Business Approved!",
          icon: (
            <CheckCircleOutlined
              style={{ fontSize: "48px", color: "#52c41a" }}
            />
          ),
          message:
            "Congratulations! Your business has been approved. You can now start accepting orders.",
          bgColor: "bg-green-50",
          borderColor: "border-green-200",
          textColor: "text-green-800",
          closable: true,
        };
      case "rejected":
        return {
          title: "Business Approval Declined",
          icon: (
            <CloseCircleOutlined
              style={{ fontSize: "48px", color: "#ff4d4f" }}
            />
          ),
          message:
            "Unfortunately, your business application was not approved. Please contact support for more information.",
          bgColor: "bg-red-50",
          borderColor: "border-red-200",
          textColor: "text-red-800",
          closable: false,
        };
      default:
        return null;
    }
  };

  const config = getModalConfig(status);

  if (!config) return null;

  return (
    <Modal
      open={visible}
      footer={null}
      closable={config.closable}
      maskClosable={config.closable}
      centered
      className="approval-modal"
      width={500}
    >
      <div
        className={`p-8 rounded-lg ${config.bgColor} ${config.borderColor} border-2 text-center`}
      >
        <div className="mb-6">{config.icon}</div>
        <h2 className={`text-2xl font-bold mb-4 ${config.textColor}`}>
          {config.title}
        </h2>
        <p className={`text-lg ${config.textColor} leading-relaxed`}>
          {config.message}
        </p>
        {status === "pending" && (
          <div className="mt-6">
            <button
              onClick={onContinue}
              className="bg-yellow-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-yellow-700 transition"
            >
              Continue
            </button>
          </div>
        )}
        {status === "approved" && (
          <div className="mt-6">
            <button
              onClick={onClose}
              className="bg-green-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-green-700 transition"
            >
              Get Started
            </button>
          </div>
        )}
        {status === "rejected" && (
          <div className="mt-6">
            <button
              onClick={onClose}
              className="bg-red-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-red-700 transition"
            >
              Back to Home
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PendingApprovalModal;
